import md5 from 'crypto-js/md5'
import sha256 from 'crypto-js/sha256'
import consoleLogger from '../../../../../../modules/console-logger'

const hashedEmails = ({ config }) => {
  const [consoleLog] = consoleLogger('AdsLog')
  if (config) {
    if (config.windowFunction) {
      const email = window[config.windowFunction]()
      if (email) {
        const md5Email = md5(email)
        const sha256Email = sha256(email)

        const hashedConfig = {
          bidders: ['criteo'],
          config: {
            ortb2: {
              user: {
                ext: {
                  data: {
                    eids: [
                      {
                        source: 'https://www.stol.it',
                        uids: [
                          {
                            id: md5Email.toString(),
                            atype: 3,
                            ext: {
                              stype: 'hemmd5',
                            },
                          },
                          {
                            id: sha256Email.toString(),
                            atype: 3,
                            ext: {
                              stype: 'hemsha256',
                            },
                          },
                        ],
                      },
                    ],
                  },
                },
              },
            },
          },
        }
        consoleLog('PREBID Hashed Emails', hashedConfig, 'Ads')

        window.pbjs.setBidderConfig(hashedConfig)
      } else {
        consoleLog('PREBID Hashed Emails', 'no email- ' + email, 'Ads')
      }
    } else {
      consoleLog('PREBID Hashed Emails', 'Window Function missing in Config', 'Ads')
    }
  }
}

export default hashedEmails
